module.exports = __webpack_public_path__ + "img/icon_img5.8f9ca8f3.png";